import axios from "../../axios/axios";

import * as apis from "../../apis";
import * as errors from "../../errors"
import * as successes from "../../successes"

import {getAxiosTokenConfig} from "../../helpers";

import {notifyError, notifySuccess} from "../../toast-notifications";


// GET EMAILS LEFT
export const GET_EMAILS_LEFT_REQUEST = "GET_EMAILS_LEFT_REQUEST";
export const GET_EMAILS_LEFT_SUCCESS = "GET_EMAILS_LEFT_SUCCESS";
export const GET_EMAILS_LEFT_ERROR = "GET_EMAILS_LEFT_ERROR";

export const getEmailsLeftRequest = () => {
    return {
        type: GET_EMAILS_LEFT_REQUEST,
        loading: true
    };
};
export const getEmailsLeftSuccess = (emailsLeft, emailsUsed, emailsMax) => {
    return {
        type: GET_EMAILS_LEFT_SUCCESS,
        loading: false,
        error: null,
        emailsLeft,
        emailsUsed,
        emailsMax
    };
};
export const getEmailsLeftError = (error) => {
    return {
        type: GET_EMAILS_LEFT_ERROR,
        loading: false,
        error
    };
};
export const getEmailsLeft = () => {
    return dispatch => {
        dispatch(getEmailsLeftRequest());
        axios.get(apis.GET_EMAILS_LEFT_API, getAxiosTokenConfig())
            .then(response => {
                const emailsLeft = response.data["emails-left"];
                const emailsUsed = response.data["emails-used"];
                const emailsMax = response.data["emails-max"];
                dispatch(getEmailsLeftSuccess(emailsLeft, emailsUsed, emailsMax));
            })
            .catch(error => {
                dispatch(getEmailsLeftError(errors.GET_EMAILS_LEFT_ERROR));
                notifyError(errors.GET_EMAILS_LEFT_ERROR);
            });
    };
};

// SEND EMAIL
export const SEND_EMAIL_REQUEST = "SEND_EMAIL_REQUEST";
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS";
export const SEND_EMAIL_ERROR = "SEND_EMAIL_ERROR";

export const sendEmailRequest = () => {
    return {
        type: SEND_EMAIL_REQUEST,
        loading: true
    };
};
export const sendEmailSuccess = () => {
    return {
        type: SEND_EMAIL_SUCCESS,
        loading: false,
        error: null
    };
};
export const sendEmailError = (error) => {
    return {
        type: SEND_EMAIL_ERROR,
        loading: false,
        error
    };
};
export const sendEmail = (customers, subject, plainContent, htmlContent) => {
    return dispatch => {
        dispatch(sendEmailRequest());
        const data = {
            customers: customers,
            subject: subject,
            text_message: plainContent,
            message: htmlContent
        };
        return new Promise((resolve, reject) => {
            axios.post(apis.SEND_EMAIL_API, data, getAxiosTokenConfig())
                .then(response => {
                    dispatch(sendEmailSuccess());
                    notifySuccess(successes.SEND_EMAIL_SUCCESS);
                    resolve();
                })
                .catch(error => {
                    dispatch(sendEmailError(errors.SEND_EMAIL_ERROR));
                    notifyError(errors.SEND_EMAIL_ERROR);
                    reject();
                });
        });
    };
};

// ADD MARKETING IMAGE
export const ADD_MARKETING_IMAGE_REQUEST = "ADD_MARKETING_IMAGE_REQUEST";
export const ADD_MARKETING_IMAGE_SUCCESS = "ADD_MARKETING_IMAGE_SUCCESS";
export const ADD_MARKETING_IMAGE_ERROR = "ADD_MARKETING_IMAGE_ERROR";

export const addMarketingImageRequest = () => {
    return {
        type: ADD_MARKETING_IMAGE_REQUEST,
        loading: true
    };
};
export const addMarketingImageSuccess = () => {
    return {
        type: ADD_MARKETING_IMAGE_SUCCESS,
        loading: false,
        error: null
    };
};
export const addMarketingImageError = (error) => {
    return {
        type: ADD_MARKETING_IMAGE_ERROR,
        loading: false,
        error
    };
};
export const addMarketingImage = (imageFile) => {
    return dispatch => {
        dispatch(addMarketingImageRequest());
        const formData = new FormData();
        formData.append('image', imageFile);
        return new Promise((resolve, reject) => {
            axios.post(apis.ADD_MARKETING_IMAGE_API, formData, getAxiosTokenConfig())
                .then(response => {
                    dispatch(addMarketingImageSuccess());
                    resolve(response.data);
                })
                .catch(error => {
                    dispatch(addMarketingImageError(errors.ADD_MARKETING_IMAGE_ERROR));
                    notifyError(errors.ADD_MARKETING_IMAGE_ERROR);
                    reject();
                });
        });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/marketing.js